
async function load() {
  const files: Record<string, any> = import.meta.glob(`./**/*.json`);
  const result = {};

  for (const path in files) {
    
    const module = await files[path]();
    const relativePath = path.replace('.json', '');
    const keys = relativePath.substring(2).split('/'); // Split the path into parts based on folders

    setNestedProperty(result, keys, module.default);
  }

  return result;

  function setNestedProperty(obj: Record<string, any>, keys: string[], value: any) {
    let current = obj;
    keys.forEach((key, index) => {
      if (index === keys.length - 1) {
        current[key] = value;
      } else {
        if (!current[key]) {
          current[key] = {};
        }
        current = current[key];
      }
    });
  };
}

export default (await load()) as Record<string, any>;
